import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMoteByUserid,setofUpdatedashboardBokaTV,decrypt,encrypt } from 'actions'
import CircularProgress from "../Components/CircularProgress";
// import CircularProgress from "../../CircularProgress/DesktopCircularProgress";
import {isEmpty,isUndefined} from 'lodash'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY } = accountsData 
    const { BokadMote,DashboardAnpassadFilterOption,UserMoteBudget} = DashBoard;
    return {
        authUser,BokadMote,DashboardAnpassadFilterOption,UserMoteBudget,updatedashboardBokaTY
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getMoteByUserid: (userid,Afid,DashboardAnpassadFilterOption) => dispatch(getMoteByUserid(userid,Afid,DashboardAnpassadFilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    }
}
class ExtraLargeBokadeMöten extends Component {
    state={
        BokadMote:0,
        UserMoteBudget:0,
        DashboardAnpassadFilterOption:[],
        done: true
    }
    intervalID = null
    componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getBMBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
             if(res.data.success){
                                        let endata = decrypt(res.data.encryptedData,res.data.iv)
                                        let ndate = JSON.parse(endata)
                                        this.setState({ 
                                            BokadMote:ndate.results.BokadMote,
                                            UserMoteBudget:ndate.results.UserMoteBudget
                                         });
                                        this.initiateInterval() 
                                       // this.setState({done: true})  
                                    }
             
        })

      
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                  //  this.setState({done: false})
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                axios.get(`kontos/DashBoard/getBMBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    BokadMote:ndate.results.BokadMote,
                    UserMoteBudget:ndate.results.UserMoteBudget
                 });
                this.initiateInterval() 
               // this.setState({done: true})  
            }
                })
            }
            },
            180000
        );
       
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
       /*  setTimeout(()=> {
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            this.props.getMoteByUserid(userid,Afid,this.props.DashboardAnpassadFilterOption)
        }, 30000);*/
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            axios.get(`kontos/DashBoard/getBMBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    BokadMote:ndate.results.BokadMote,
                    UserMoteBudget:ndate.results.UserMoteBudget
                 });
                this.initiateInterval() 
               // this.setState({done: true})  
            }
            })
            this.props.setofUpdatedashboardBokaTV()
        }
       
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number > 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return parseInt(number)
        }
    }
    render() {
        let Budget = (this.state.UserMoteBudget=== 0)?0:this.state.UserMoteBudget
        return (<>{
            this.state.done === false?
            <Skeleton variant="rectangular"  height={'94%'} style={{margin:10,backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
            :
          <div className="text-center d-flex flex-column align-items-center justify-content-between h-100" style={{ color: 'white' }}>
                <div className="" 
                style={{ marginTop: '12px' }}>
                    <h2 className="col m-0 p-0" style={{fontWeight:"500",color:this.props.FontColor}}><b><IntlMessages id="Event.Booked"/></b></h2>
                    <h4 className="col m-0 p-0" style={{fontWeight:"300",color:this.props.FontColor}}><b><IntlMessages id="Outcome.Budget"/></b></h4>                
                  {/*  <div style={{ marginTop: '-14px', marginRight:'10px' }}>
                        <CustomMenu />
                    </div>
                    */}
                </div>

                <div className="d-flex justify-content-center h-100 w-100 align-items-center">
                  <div style={{zIndex: 0}} className="position-absolute">
                    <CircularProgress 
                      isFrom={1}
                      size={160}
                      Budget={Budget} 
                      MonthVunnen={this.state.BokadMote} 
                      percentage={parseInt((this.state.MonthVunnen/Budget)*100)}/>
                  </div>
                  <div>
                      <p style={{fontSize:40, margin:'4rem 0',fontWeight:"400",color:this.props.FontColor}}>{parseInt((this.state.BokadMote/Budget)*100)}%</p>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-end w-100 px-2 pb-1" 
                >
                    <p style={{fontSize:25,fontWeight:"300",color:this.props.FontColor}}>{this.formatNumber(this.state.BokadMote)}st</p>
                    <b style={{fontSize:20,fontWeight:"300",color:this.props.FontColor}}>/ {this.formatNumber(Budget)}</b>
                </div>
            </div>
    }</>
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(ExtraLargeBokadeMöten);

